<template>
  <v-container grid-list-xl>
    <div class="head">
      <div class="title">
      <h2 class="pl-4 mt-4">
        <span>Graphic</span>
        <span class="blue--text">Portfolio</span>
      </h2>
      </div>
      <div class="date mt-3">
        <h3>
        Total Projects Undertaken
        </h3>
      <v-chip color="#2196f3" text-color="white" label>
        <h4>
        {{totalWork}}
        </h4>
      </v-chip>
      </div>
    </div>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="data.dialog"
        lazy
        min-width="310"
        max-width="1080"  
        min-height="720"
        v-for="data in GraphicPortfolio"
        :key="data.name"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="data.img_src"
                height="630"
                :alt="data.name"
                lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"
              ></v-img>
              <v-card-title primary-title class="justify-center pb-0 blue--text">{{
                data.name
              }}
              </v-card-title>
              <v-card-title class="justify-center mt-0 pt-0">
              {{ data.for }}
              </v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="data.dialog">
          <v-img :src="data.img_src" style="overflow: hidden;"></v-img>
        </v-card>
      </v-dialog>
    </v-layout>
      The page is still incomplete.
     <v-btn
      class="ma-2 white--text text-center d-flex justify-content-center"
      href="http://designs.midhunnair.ml" target="_blank"
      outlined
      color="#2196f3"
      >
        Visit Old Graphic Portfolio Site
      </v-btn>
  </v-container>
</template>

<script>
import { query, collection, getDocs } from "firebase/firestore"
import db from '../../firebase/init.js'

export default {
  metaInfo: {
    title: "Graphic Portfolio ",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Midhun Nair's Graphic Adobe PhotoShop Logo Design Instagram Poster",
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun' Space" },
      { property: "og:site_name", content: "Midhun' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://Midhun.space" },
      {
        property: "og:image",
        content: "https://i.imgur.com/Dcz2PGx.jpg",
      },
      {
        property: "og:description",
        content:
          "Midhun Nair's Graphic Adobe PhotoShop Logo Design Instagram Poster",
      },
    ],
  },
  data() {
    return {
      GraphicPortfolio: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      // query to get all docs in 'countries' collection
      const querySnap = await getDocs(query(collection(db, 'GraphicPortfolio')));

      // add each doc to 'countries' array
      this.totalWork=querySnap.size;
      querySnap.forEach((doc) => {
        this.GraphicPortfolio.push(doc.data())
      })

    }
  }
};
</script>

<style  scoped>
.head{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.date{
  margin-left: 24px;
  display: flex;
}

.date h3{
  padding-top: 8px;
}
</style>